import { Droplet } from 'lucide-react'
import { SeriesChart, VitalChartFrame, vitalNumber } from '../VitalPlot/VitalPlot'
import '../VitalPlot/VitalPlot.css'
import './GlucoseChart.css'

function formatGlucose(value) {
  if (!Number.isFinite(value)) return '—'
  return `${Math.round(value)} mg/dL`
}

function GlucoseChart({ points = [] }) {
  const series = points
    .map((point) => ({ at: point.at, value: vitalNumber(point.bloodGlucose) }))
    .filter((point) => point.value != null)
    .map((point) => ({
      at: point.at,
      value: point.value,
      label: `${Math.round(point.value)}`
    }))
  const latest = series.length ? series[series.length - 1].value : null
  const values = series.map((point) => point.value)
  const dataMin = values.length ? Math.min(...values) : 90
  const dataMax = values.length ? Math.max(...values) : 140
  const yMin = Math.min(40, Math.floor(Math.min(dataMin, 70) / 20) * 20)
  const yMax = Math.max(200, Math.ceil(Math.max(dataMax, 180) / 20) * 20)
  const step = yMax - yMin > 160 ? 40 : 20
  const ticks = []
  for (let tick = yMin; tick <= yMax; tick += step) ticks.push(tick)

  return (
    <VitalChartFrame
      className="glucose-chart"
      icon={<Droplet size={16} />}
      title="Glicemia (mg/dL)"
      badgeLabel="Glicemia Atual:"
      badgeValue={formatGlucose(latest)}
      legend={[
        { mark: 'is-alert', label: 'Hiperglicemia (≥ 180 mg/dL)' },
        { mark: 'is-low', label: 'Hipoglicemia (< 70 mg/dL)' },
        { mark: 'is-safe', label: 'Faixa usual (70 - 140 mg/dL)' }
      ]}
      empty={series.length === 0 ? 'Nenhuma glicemia registrada para este paciente.' : ''}
    >
      <SeriesChart
        points={series}
        yMin={yMin}
        yMax={yMax}
        ticks={ticks}
        tickLabel={(tick) => String(tick)}
        band={{ from: 70, to: 140 }}
        guides={[
          { key: 'low', value: 70, className: 'vital-guide-low' },
          { key: 'high', value: 140, className: 'vital-guide-safe' },
          { key: 'hyper', value: 180, className: 'vital-guide-alert' }
        ]}
        gradientFrom="#d97706"
        gradientTo="#fde68a"
        ariaLabel="Glicemia"
      />
    </VitalChartFrame>
  )
}

export default GlucoseChart
